export default "__VITE_ASSET__DNKW7SXw__"